import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PanneauxSolaires = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const renderIcon = (iconType) => {
    const iconProps = { width: "35", height: "35", fill: "#4CAF50" };
    
    switch(iconType) {
      case 'solar':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z"/>
          </svg>
        );
      case 'growth':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z"/>
          </svg>
        );
      case 'money':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M5,6H23V18H5V6M14,9A3,3 0 0,1 17,12A3,3 0 0,1 14,15A3,3 0 0,1 11,12A3,3 0 0,1 14,9M9,8A2,2 0 0,1 7,10V14A2,2 0 0,1 9,16H19A2,2 0 0,1 21,14V10A2,2 0 0,1 19,8H9M1,10H3V20H19V22H1V10Z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const avantages = [
    {
      title: t('panneaux.avantage1.title'),
      description: t('panneaux.avantage1.description'),
      icon: "solar",
      color: "#4CAF50"
    },
    {
      title: t('panneaux.avantage2.title'),
      description: t('panneaux.avantage2.description'),
      icon: "growth",
      color: "#4CAF50"
    },
    {
      title: t('panneaux.avantage3.title'),
      description: t('panneaux.avantage3.description'),
      icon: "money",
      color: "#FF6B35"
    }
  ];

  return (
    <section className="panneaux-solaires section-animate" id="panneaux-solaires" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('panneaux.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('panneaux.subtitle')}
          </p>
        </div>
        
        <div className="avantages-solaires">
          {avantages.map((avantage, index) => (
            <div key={index} className="avantage-solaire stagger-item card-premium focus-premium" style={{'--accent-color': avantage.color}} tabIndex="0">
              <div className="avantage-icon">
                {renderIcon(avantage.icon)}
              </div>
              <div className="avantage-content">
                <h3 className="avantage-title">{avantage.title}</h3>
                <p className="avantage-description">{avantage.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="cta-solaire">
          <a href="#contact" className="btn btn-primary btn-lg btn-ripple focus-premium">
            {t('panneaux.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default PanneauxSolaires; 